/**
 * 灾害事故
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("disasterAccidentModule", [
	"disasterAccidentRouter", //灾害事故总路由
    "naturalDisasterModule", //自然灾害
    "safetyAccidentModule", //安全事故
    "navTplModule",//公共导航
]);